// import React from "react";

// const NewsData = [
//     {
//         id: 1,
//         title: "Breaking News: Market Hits Record High!",
//         description: "The stock market reached an all-time high today, with tech stocks leading the charge.",
//     },
//     {
//         id: 2,
//         title: "Tech Innovations of 2025",
//         description: "A closer look at groundbreaking technologies set to redefine industries this year.",
//     },
//     {
//         id: 3,
//         title: "Climate Action: What’s Next?",
//         description: "Global leaders gather to discuss actionable solutions for climate change.",
//     },
// ];

// const MediaNews = () => {
//     return (
//         <div style={{ width: "100%", margin: "0", padding: "20px" }}>
//             <div className="card h-100 radius-8 border" style={{ width: "100%" }}>
//                 <div className="card-body p-24">
//                     <h6 className="mb-4 fw-bold text-lg">Latest News</h6>
//                     <div >
//                         {NewsData.map((news) => (
//                             <div
//                                 key={news.id}
//                                 className="news-item"
//                                 style={{
//                                     width: "100%",
//                                     padding: "16px",
//                                     marginBottom: "16px",
                                    
//                                 }}
//                             >
//                                 <h6 className="fw-bold text-md mb-2">{news.title}</h6>
//                                 <p className="text-sm text-secondary-light mb-0">
//                                     {news.description}
//                                 </p>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default MediaNews;

import React, { useState, useEffect } from "react";

const MediaNews = () => {
    const BaseUrl = process.env.REACT_APP_API;

  // State to hold RSS feed data
  const [rssData, setRssData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [newsPerPage] = useState(5); 
  // Fetch RSS feed data when the component mounts
  useEffect(() => {
    // Replace this URL with your actual API endpoint
    const fetchRssFeed = async () => {
      try {
        const response = await fetch(`${BaseUrl}/getMediumArticle`); 
        const data = await response.json();
        if (data.status === "success") {
          setRssData(data.data); // Set the RSS data
        } else {
          setError("Failed to fetch RSS feed data.");
        }
      } catch (err) {
        setError("Error fetching the RSS feed.");
      } finally {
        setLoading(false); // Stop loading
      }
    };

    fetchRssFeed();
  }, []);

  if (loading) {
    return <p className="loading-text">Loading Media Articles...</p>;
  }

  if (error) {
    return <div>{error}</div>;
  }


  
  // Pagination logic
  const indexOfLastNews = currentPage * newsPerPage;
  const indexOfFirstNews = indexOfLastNews - newsPerPage;
  const currentNews = rssData.slice(indexOfFirstNews, indexOfLastNews);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);


    // Function to convert UTC to IST
    const convertToIST = (dateString) => {
      const date = new Date(dateString);
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
        timeZone: 'Asia/Kolkata',
      };
      return new Intl.DateTimeFormat('en-IN', options).format(date);
    };

  return (
    <div style={{ width: "100%", margin: "0", padding: "20px" }}>
    <div className="card h-100 radius-8 border" style={{ width: "100%" }}>
        <div className="card-body p-24">
    <div className="crypto-news-container">
      <ul className="news-list">
          {currentNews.map((item) => (
          <li key={item.id} className="news-item">
            <h6 className="text-primary-light">{item.title}</h6>
            <a href={item.link} target="_blank" rel="noopener noreferrer" className="news-item-link">
              Read more
            </a>
            <p className="news-item-date">{convertToIST(item.pubDate)}</p> 

          </li>
        ))}
      </ul>
          

      <div className="pagination" style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "5px",
            marginTop: "10px",
          }}>
            {Array.from({ length: Math.ceil(rssData.length / newsPerPage) }, (_, index) => (
              <button
                key={index}
                onClick={() => paginate(index + 1)}
                className={`pagination-button ${currentPage === index + 1 ? "active" : ""}`}
                style={{
                  padding: "6px 12px",
                  fontSize: "14px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  cursor: "pointer",
                  background: currentPage === index + 1 ? "#007bff" : "#f8f9fa",
                  color: currentPage === index + 1 ? "#fff" : "#000",
                  minWidth: "30px",
                  transition: "all 0.3s ease",
                }}
              >
                {index + 1}
              </button>
            ))}
           </div>

         
    </div>
    </div>
    </div>
    </div>

  );
};

export default MediaNews;
